/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=(n,l)=>n&&((...n)=>l.warn("DEBUG:",...n))||(()=>null),l=!1;export{l as DEBUG_ATTR_UPDATES,n as createDebugLogger};
